import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 4,
        borderTop: '1px solid rgba(200, 162, 77, 0.1)',
        background: '#FFFFFF',
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            gap: 1,
          }}
        >
          <Typography
            variant="body2"
            sx={{ color: '#9CA3AF', fontSize: '0.85rem' }}
          >
            © {new Date().getFullYear()} Kasidej Cha-umpong. All rights reserved.
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: '#C5C0B6',
              fontSize: '0.78rem',
            }}
          >
            Last updated: 16 October 2025
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: '#C5C0B6',
              fontSize: '0.78rem',
            }}
          >
            Built with React & Material UI
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
